import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex items-center justify-center w-full min-h-[560px] md:min-h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=An%20overhead%20editorial%20flat%20lay%20of%20diverse%20fashion%20and%20lifestyle%20items%20including%20sneakers%20a%20denim%20jacket%20a%20cap%20a%20backpack%20sunglasses%20and%20a%20watch%20arranged%20in%20a%20loose%20grid%20with%20generous%20negative%20space%20on%20a%20warm%20neutral%20taupe%20background%2C%20bright%20soft%20natural%20lighting%2C%20clean%20airy%20composition%20with%20a%20subtle%20bokeh%20of%20blurred%20greenery%20at%20the%20corners%2C%20high%20detail%2C%20premium%20e-commerce%20aesthetic&width=1600&height=900&seq=hero-basetao&orientation=landscape&nocache=true"
        alt="Basetao Spreadsheet product research flat lay"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-white text-xs font-medium backdrop-blur-sm whitespace-nowrap">
          <i className="ri-sparkling-line text-sm" />
          {t("heroEyebrow")}
        </span>
        <h1 className="mt-6 mx-auto max-w-4xl font-heading text-3xl md:text-5xl font-bold text-white leading-tight">
          {t("heroH1")}
        </h1>
        <p className="mt-5 mx-auto max-w-2xl text-base md:text-lg text-white/85 leading-relaxed">
          {t("heroText")}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("heroCta1")}
            <i className="ri-arrow-right-up-line text-base" />
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("heroCta2")}
            <i className="ri-shopping-bag-3-line text-base" />
          </a>
        </div>

        <p className="mt-8 text-xs text-white/70 whitespace-nowrap">
          <i className="ri-checkbox-circle-line mr-1" />
          {t("heroTrust")}
        </p>
      </div>
    </section>
  );
}